import * as deskBookingsApi from '../../api/desk-bookings';

export const FETCH_DESK_LABELS = 'FETCH_DESK_LABELS';
export const FETCH_DESK_LABELS_PENDING = 'FETCH_DESK_LABELS_PENDING';
export const FETCH_DESK_LABELS_FULFILLED = 'FETCH_DESK_LABELS_FULFILLED';
export const FETCH_DESK_LABELS_REJECTED = 'FETCH_DESK_LABELS_REJECTED';

// The meta key lets the reducer drop a response for a week the user has already flipped away from.
export const fetchDeskLabels = (startDate: string, endDate: string, userId?: number) => ({
  type: FETCH_DESK_LABELS,
  payload: deskBookingsApi.getDeskLabelsByDate(startDate, endDate, userId),
  meta: { key: `${startDate}|${endDate}|${userId || ''}` },
});
